module.exports = __webpack_public_path__ + "static/media/Booking_policy.e9ee7e93.pdf";